import { Button } from '@/components/ui/button';
import { TableCell, TableRow } from '@/components/ui/table';
import { useSortable } from '@dnd-kit/react/sortable';
import { GripVertical } from 'lucide-react';
import { Account } from '@liquidbudget/common';
import { getAccountTypeIcon } from '@/components/account-form/account-icon';

interface Props {
  id: string;
  index: number;
  group: string;
  account: Account;
}

export function AccountSortItem({ id, index, group, account }: Props) {
  const { handleRef, ref } = useSortable({
    id,
    index,
    type: 'account',
    accept: 'account',
    group,
  });

  const IconComponent = getAccountTypeIcon(account.type);

  return (
    <TableRow ref={ref}>
      <TableCell>
        <div className="flex items-center justify-between pl-2">
          <div className="flex items-center gap-2">
            <IconComponent size={16} />
            <span>{account.name}</span>
          </div>
          <Button ref={handleRef} variant="outline" size="icon" className="h-6 w-6 cursor-grab active:cursor-grabbing">
            <GripVertical className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
